<div class="example-header">
    <button mat-button (click)="previousClicked()">
        <i class="bi bi-chevron-left"></i>
    </button>
    <span class="example-header-label">{{periodLabel}}</span>
    <button mat-button (click)="nextClicked()">
        <i class="bi bi-chevron-right"></i>
    </button>
</div>